import { configureStore } from '@reduxjs/toolkit';
import addressesReducer from './slices/addressesSlice';
import companiesReducer from './slices/companiesSlice';
import companyFilesReducer from './slices/companyFilesSlice';
import companyInvestorsReducer from './slices/companyInvestorsSlice';
import companyMembersReducer from './slices/companyMembersSlice';
import companyPostsReducer from './slices/companyPostsSlice';
import currentInvestorReducer from './slices/currentInvestorSlice';
import currentUserReducer from './slices/currentUserSlice';
import filesReducer from './slices/filesSlice';
import financialReportsReducer from './slices/financialReportsSlice';
import investmentsReducer from './slices/investmentsSlice';
import investorsReducer from './slices/investorsSlice';
import notificationsReducer from './slices/notificationsSlice';
import postFilesReducer from './slices/postFilesSlice';
import postsReducer from './slices/postsSlice';
import profilePreferencesReducer from './slices/profilePreferencesSlice';
import profilePropertiesReducer from './slices/profilePropertiesSlice';
import profilesReducer from './slices/profilesSlice';
import propertiesReducer from './slices/propertiesSlice';
import unreadNotificationsReducer from '@/store/slices/unreadNotificationsCountSlice';
import usersReducer from './slices/usersSlice';

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  reducer: {
    addresses: addressesReducer,
    companies: companiesReducer,
    companyFiles: companyFilesReducer,
    companyInvestors: companyInvestorsReducer,
    companyMembers: companyMembersReducer,
    companyPosts: companyPostsReducer,
    currentInvestor: currentInvestorReducer,
    currentUser: currentUserReducer,
    files: filesReducer,
    financialReports: financialReportsReducer,
    investments: investmentsReducer,
    investors: investorsReducer,
    notifications: notificationsReducer,
    postFiles: postFilesReducer,
    posts: postsReducer,
    profilePreferences: profilePreferencesReducer,
    profileProperties: profilePropertiesReducer,
    profiles: profilesReducer,
    properties: propertiesReducer,
    unreadNotificationsCount: unreadNotificationsReducer,
    users: usersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
